import { Component, OnInit } from '@angular/core';
import { GRADIENT_ICONS, IMAGES, NAV_HOVER_IMAGES } from 'src/app/constants/imagePath';
import { ROUTES } from 'src/app/constants/Routes';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  isOpen = false; // Tracks sidebar state (open/closed)
  mobileSections: Record<string, boolean> = {
    solutions: true,
    products: false,
    about: false
  };
  mobileSubsections: Record<string, boolean> = {
    solutionsBusiness: true,
    solutionsConsumers: false,
    productsConnectiq: true,
    productsHardware: false
  };
  Routes = ROUTES;
  Images = IMAGES;
  NavImages = NAV_HOVER_IMAGES;
  GradientIcons = GRADIENT_ICONS;

  toggleSidebar() {
    this.isOpen = !this.isOpen;
  }

  toggleMobileSection(section: string): void {
    this.mobileSections[section] = !this.mobileSections[section];
  }

  toggleMobileSubsection(section: string): void {
    this.mobileSubsections[section] = !this.mobileSubsections[section];
  }

  constructor() { }

  ngOnInit() {

  }

}
